<template>
    <div v-if="model">
        <rkm-area
            no-margin-top
            title="Filtros"
            type="fieldset"
        >
            <rkm-form
                ref="Form"
                show-legend
            >
                <rkm-row>
                    <rkm-col cols="6">
                        <rkm-form-date-picker
                            :end-validations="validations.periodo"
                            :range-inline="false"
                            :start-validations="validations.periodo"
                            end-label="Até"
                            range
                            start-label="Período de"
                            v-model="model.periodo"
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <rkm-form-select
                            :options="form.anos"
                            :validations="validations.ano"
                            @change="handleAnoChange"
                            label="Ano"
                            show-default-option
                            v-model="model.ano"
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <rkm-form-select
                            :options="form.quadrimestres"
                            :validations="validations.quadrimestre"
                            @change="handleQuadrimestreChange"
                            label="Quadrimestre"
                            show-default-option
                            v-model="model.quadrimestre"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="3">
                        <rkm-form-select
                            :options="form.unidades"
                            @change="handleUnidadeChange"
                            default-option-text="Todas"
                            label="Unidade"
                            show-default-option
                            text-field="nomeFantasia"
                            v-model="model.unidadeId"
                            value-field="id"
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <rkm-form-select
                            :options="form.equipes"
                            @change="handleEquipeChange"
                            default-option-text="Todas"
                            label="Equipe"
                            show-default-option
                            text-field="descricao"
                            v-model="model.equipeId"
                            value-field="id"
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <rkm-form-multiselect
                            :options="form.boasPraticas"
                            :select-limit="null"
                            label="Boas Práticas"
                            option-name-key="text"
                            option-text-selecteds="boa prática selecionada"
                            v-model="model.boasPraticas"
                            value-field="value"
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <rkm-form-select
                            :options="form.sexos"
                            default-option-text="Todas"
                            label="Sexo"
                            show-default-option
                            text-field="descricao"
                            v-model="model.sexoId"
                            value-field="id"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="6">
                        <rkm-form-group
                            class="mb-0"
                            label="Faixa etária inicial"
                        >
                            <rkm-row>
                                <rkm-col cols="4">
                                    <rkm-form-input
                                        :validations="validations.idadeAnosMinimo"
                                        @change="handleIdadeAnosMinimoChange"
                                        append="Anos"
                                        number
                                        v-model="model.idadeAnosMinimo"
                                    />
                                </rkm-col>

                                <rkm-col cols="4">
                                    <rkm-form-input
                                        :validations="validations.idadeMesesMinimo"
                                        @change="handleIdadeMesesMinimoChange"
                                        append="Meses"
                                        number
                                        v-model="model.idadeMesesMinimo"
                                    />
                                </rkm-col>

                                <rkm-col cols="4">
                                    <rkm-form-input
                                        :validations="validations.idadeDiasMinimo"
                                        @change="handleIdadeDiasMinimoChange"
                                        append="Dias"
                                        number
                                        v-model="model.idadeDiasMinimo"
                                    />
                                </rkm-col>
                            </rkm-row>
                        </rkm-form-group>
                    </rkm-col>

                    <rkm-col cols="6">
                        <rkm-form-group
                            class="mb-0"
                            label="Faixa etária final"
                        >
                            <rkm-row>
                                <rkm-col cols="4">
                                    <rkm-form-input
                                        :validations="validations.idadeAnosMaximo"
                                        @change="handleIdadeAnosMaximoChange"
                                        append="Anos"
                                        number
                                        v-model="model.idadeAnosMaximo"
                                    />
                                </rkm-col>

                                <rkm-col cols="4">
                                    <rkm-form-input
                                        :validations="validations.idadeMesesMaximo"
                                        @change="handleIdadeMesesMaximoChange"
                                        append="Meses"
                                        number
                                        v-model="model.idadeMesesMaximo"
                                    />
                                </rkm-col>

                                <rkm-col cols="4">
                                    <rkm-form-input
                                        :validations="validations.idadeDiasMaximo"
                                        @change="handleIdadeDiasMaximoChange"
                                        append="Dias"
                                        number
                                        v-model="model.idadeDiasMaximo"
                                    />
                                </rkm-col>
                            </rkm-row>
                        </rkm-form-group>
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="6">
                        <rkm-form-input-autocomplete
                            :repository="repositories.relatorioCuidadoPessoaComDiabete"
                            :request-query-string-params="requestQueryStringParams"
                            :search-fields="fields.autocomplete"
                            :text-field="value => `${value.nome}${value.nomeSocial ? ` (${value.nomeSocial})` : ''}${value.cns ? ' - ' + value.cns : ''}`"
                            :validations="validations.paciente"
                            label="Paciente"
                            placeholder="Digite o nome, nome social, data de nascimento ou prontuário do paciente"
                            uppercase
                            v-model="model.paciente"
                        />
                    </rkm-col>

                    <rkm-col cols="auto">
                        <rkm-form-checkbox
                            :label="false"
                            v-model="model.buscaAtiva"
                            tooltip-text="Exibe somente pacientes com pendência em uma ou mais boas práticas do indicador."
                        >
                            Busca ativa

                        </rkm-form-checkbox>
                    </rkm-col>

                    <rkm-col>
                        <rkm-button
                            :label="false"
                            @click="$refs.Form.validate(search)"
                            color="primary"
                        >
                            Buscar
                        </rkm-button>

                        <rkm-button
                            :label="false"
                            @click="reset"
                        >
                            Limpar
                        </rkm-button>
                    </rkm-col>
                </rkm-row>
            </rkm-form>
        </rkm-area>

        <template v-if="itensAgrupados.length > 0">
            <rkm-area
                no-margin-top
                title="Totalizadores"
            >
                <template v-slot:trailing>
                    <rkm-button
                        @click="print"
                        color="info"
                        small
                        title="Imprimir"
                    >
                        <rkm-icon icon="print" />
                    </rkm-button>

                    <rkm-button
                        @click="exportTo"
                        color="info"
                        small
                        title="Exportar"
                    >
                        <rkm-icon icon="file-export" />
                    </rkm-button>
                </template>

                <rkm-row>
                    <rkm-col cols="3">
                        <rkm-form-input
                            :value="totalizadores.pacientes"
                            label="Total de pacientes"
                            disabled
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <rkm-form-input
                            :value="totalizadores.equipes"
                            label="Total de equipes"
                            disabled
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <rkm-form-input
                            :value="totalizadores.microareas"
                            label="Total de microáreas"
                            disabled
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <rkm-form-input
                            :value="totalizadores.denominador"
                            label="Denominador"
                            disabled
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="3">
                        <rkm-form-input
                            :value="totalizadores.numerador"
                            label="Numerador"
                            disabled
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <rkm-form-input
                            :value="totalizadores.resultado"
                            label="Resultado"
                            disabled
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <rkm-form-input
                            :value="totalizadores.percentualBoasPraticasA"
                            disabled
                            label="% Boa prática A"
                            tooltip-right="Pelo menos 1 consulta presencial ou remota por médica(o) ou enfermeira(o) nos últimos 6 meses."
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <rkm-form-input
                            :value="totalizadores.percentualBoasPraticasB"
                            disabled
                            label="% Boa prática B"
                            tooltip-right="Pelo menos 1 aferição de pressão arterial nos últimos 6 meses."
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="3">
                        <rkm-form-input
                            :value="totalizadores.percentualBoasPraticasC"
                            disabled
                            label="% Boa prática C"
                            tooltip-right="Pelo menos 1 registro simultâneo de peso e altura nos últimos 12 meses."
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <rkm-form-input
                            :value="totalizadores.percentualBoasPraticasD"
                            disabled
                            label="% Boa prática D"
                            tooltip-right="Pelo menos 2 visitas domiciliares por ACS/TACS, com intervalo mínimo de 30 dias, nos últimos 12 meses."
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <rkm-form-input
                            :value="totalizadores.percentualBoasPraticasE"
                            disabled
                            label="% Boa prática E"
                            tooltip-right="Pelo menos 1 hemoglobina glicada solicitada ou avaliada nos últimos 12 meses."
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <rkm-form-input
                            :value="totalizadores.percentualBoasPraticasF"
                            disabled
                            label="% Boa prática F"
                            tooltip-right="“Pelo menos 1 avaliação dos pés nos últimos 12 meses."
                        />
                    </rkm-col>
                </rkm-row>
            </rkm-area>

            <rkm-area
                no-margin-top
                title="Resultado por equipe"
            >
                <rkm-table
                    :fields="fields.table.agrupados"
                    :items="itensAgrupados"
                    :sort-by="sortByAgrupados"
                    :sort-desc="sortDescAgrupados"
                    @sort-changed="onSortChangedAgrupados"
                    hide-pagination
                >
                    <template v-slot:head(resultado)>
                        Resultado
                        <span
                            title="Resultado calculado pela fórmula: (Numerador ÷ (Denominador × 100)) × 100."
                            v-rkm-tooltip.hover
                        >
                            <rkm-icon icon="info-circle" />
                        </span>
                    </template>

                    <template v-slot:head(classificacao)>
                        Classificação
                        <span
                            title="Faixa de desempenho da equipe conforme parâmetro do indicador."
                            v-rkm-tooltip.hover
                        >
                            <rkm-icon icon="info-circle" />
                        </span>
                    </template>

                    <template v-slot:head(percentualBoasPraticasA)>
                        % Boa prática A
                        <span
                            title="Pelo menos 1 consulta presencial ou remota por médica(o) ou enfermeira(o) nos últimos 6 meses."
                            v-rkm-tooltip.hover
                        >
                            <rkm-icon icon="info-circle" />
                        </span>
                    </template>

                    <template v-slot:head(percentualBoasPraticasB)>
                        % Boa prática B
                        <span
                            title="Pelo menos 1 aferição de pressão arterial nos últimos 6 meses."
                            v-rkm-tooltip.hover
                        >
                            <rkm-icon icon="info-circle" />
                        </span>
                    </template>

                    <template v-slot:head(percentualBoasPraticasC)>
                        % Boa prática C
                        <span
                            title="Pelo menos 1 registro simultâneo de peso e altura nos últimos 12 meses."
                            v-rkm-tooltip.hover
                        >
                            <rkm-icon icon="info-circle" />
                        </span>
                    </template>

                    <template v-slot:head(percentualBoasPraticasD)>
                        % Boa prática D
                        <span
                            title="Pelo menos 2 visitas domiciliares por ACS/TACS, com intervalo mínimo de 30 dias, nos últimos 12 meses."
                            v-rkm-tooltip.hover
                        >
                            <rkm-icon icon="info-circle" />
                        </span>
                    </template>

                    <template v-slot:head(percentualBoasPraticasE)>
                        % Boa prática E
                        <span
                            title="Pelo menos 1 hemoglobina glicada solicitada ou avaliada nos últimos 12 meses."
                            v-rkm-tooltip.hover
                        >
                            <rkm-icon icon="info-circle" />
                        </span>
                    </template>

                    <template v-slot:head(percentualBoasPraticasF)>
                        % Boa prática F
                        <span
                            title="Pelo menos 1 avaliação dos pés nos últimos 12 meses."
                            v-rkm-tooltip.hover
                        >
                            <rkm-icon icon="info-circle" />
                        </span>
                    </template>
                </rkm-table>
            </rkm-area>

            <rkm-area
                v-if="model.buscaAtiva && itensDesagrupados.length > 0"
                no-margin-top
                title="Busca ativa por paciente"
            >
                <rkm-table
                    :fields="fields.table.desagrupados"
                    :items="itensDesagrupados"
                    :sort-by="sortByDesagrupados"
                    :sort-desc="sortDescDesagrupados"
                    @sort-changed="onSortChangedDesagrupados"
                    hide-pagination
                >
                    <template v-slot:head(boaPraticaA)>
                        % Boa prática A
                        <span
                            title="Pelo menos 1 consulta presencial ou remota por médica(o) ou enfermeira(o) nos últimos 6 meses."
                            v-rkm-tooltip.hover
                        >
                            <rkm-icon icon="info-circle" />
                        </span>
                    </template>

                    <template v-slot:head(boaPraticaB)>
                        % Boa prática B
                        <span
                            title="Pelo menos 1 aferição de pressão arterial nos últimos 6 meses."
                            v-rkm-tooltip.hover
                        >
                            <rkm-icon icon="info-circle" />
                        </span>
                    </template>

                    <template v-slot:head(boaPraticaC)>
                        % Boa prática C
                        <span
                            title="Pelo menos 1 registro simultâneo de peso e altura nos últimos 12 meses."
                            v-rkm-tooltip.hover
                        >
                            <rkm-icon icon="info-circle" />
                        </span>
                    </template>

                    <template v-slot:head(boaPraticaD)>
                        % Boa prática D
                        <span
                            title="Pelo menos 2 visitas domiciliares por ACS/TACS, com intervalo mínimo de 30 dias, nos últimos 12 meses."
                            v-rkm-tooltip.hover
                        >
                            <rkm-icon icon="info-circle" />
                        </span>
                    </template>

                    <template v-slot:head(boaPraticaE)>
                        % Boa prática E
                        <span
                            title="Pelo menos 1 hemoglobina glicada solicitada ou avaliada nos últimos 12 meses."
                            v-rkm-tooltip.hover
                        >
                            <rkm-icon icon="info-circle" />
                        </span>
                    </template>

                    <template v-slot:head(boaPraticaF)>
                        % Boa prática F
                        <span
                            title="Pelo menos 1 avaliação dos pés nos últimos 12 meses."
                            v-rkm-tooltip.hover
                        >
                            <rkm-icon icon="info-circle" />
                        </span>
                    </template>

                    <template #cell(boaPraticaA)="{item}">
                        <rkm-icon
                            :color="!!item.boaPraticaA ? 'green' : 'red'"
                            :icon="!!item.boaPraticaA ? 'check' : 'times'"
                        />
                    </template>

                    <template #cell(boaPraticaB)="{item}">
                        <rkm-icon
                            :color="!!item.boaPraticaB ? 'green' : 'red'"
                            :icon="!!item.boaPraticaB ? 'check' : 'times'"
                        />
                    </template>

                    <template #cell(boaPraticaC)="{item}">
                        <rkm-icon
                            :color="!!item.boaPraticaC ? 'green' : 'red'"
                            :icon="!!item.boaPraticaC ? 'check' : 'times'"
                        />
                    </template>

                    <template #cell(boaPraticaD)="{item}">
                        <span v-if="item.areaTipoId === 5 && !item.boaPraticaD" class="badge badge-secondary">N/C</span>
                        <rkm-icon
                            v-else
                            :color="!!item.boaPraticaD ? 'green' : 'red'"
                            :icon="!!item.boaPraticaD ? 'check' : 'times'"
                        />
                    </template>

                    <template #cell(boaPraticaE)="{item}">
                        <rkm-icon
                            :color="!!item.boaPraticaE ? 'green' : 'red'"
                            :icon="!!item.boaPraticaE ? 'check' : 'times'"
                        />
                    </template>

                    <template #cell(boaPraticaF)="{item}">
                        <rkm-icon
                            :color="!!item.boaPraticaF ? 'green' : 'red'"
                            :icon="!!item.boaPraticaF ? 'check' : 'times'"
                        />
                    </template>
                </rkm-table>
            </rkm-area>
        </template>
    </div>
</template>

<script>
// Mixins.
import {error, file, repository, stringCase} from '@/mixins'

// Others.
import moment from 'moment'

// Vuex.
import {mapActions} from 'vuex'

export default {
    computed: {
        validations() {
            return {
                periodo: {required: this.model && this.model.ano && this.model.quadrimestre ? false : true},
                ano: {required: this.model && this.model.periodo.start && this.model.periodo.end ? false : true},
                quadrimestre: {required: this.model && this.model.periodo.start && this.model.periodo.end ? false : true},
                idadeAnosMinimo: {min_value: 0, max_value: this.model && this.model.idadeAnosMaximo ? this.model.idadeAnosMaximo : 120},
                idadeMesesMinimo: {min_value: 0, max_value: 11},
                idadeDiasMinimo: {min_value: 0, max_value: 30},
                idadeAnosMaximo: {min_value: this.model && this.model.idadeAnosMinimo ? this.model.idadeAnosMinimo : 0, max_value: 120},
                idadeMesesMaximo: {min_value: 0, max_value: 11},
                idadeDiasMaximo: {min_value: 0, max_value: 30},
            }
        },
        requestQueryStringParams() {
            return {
                periodo: {
                    start: this.model.periodo.start ? this.others.moment(this.model.periodo.start).format('DD/MM/YYYY') : null,
                    end: this.model.periodo.end ? this.others.moment(this.model.periodo.end).format('DD/MM/YYYY') : null,
                },
                ano: this.model.ano,
                quadrimestre: this.model.quadrimestre,
                unidade_id: this.model.unidadeId,
                equipe_id: this.model.equipeId,
                sexo_id: this.model.sexoId,
                idade_anos_minimo: this.model.idadeAnosMinimo,
                idade_meses_minimo: this.model.idadeMesesMinimo,
                idade_dias_minimo: this.model.idadeDiasMinimo,
                idade_anos_maximo: this.model.idadeAnosMaximo,
                idade_meses_maximo: this.model.idadeMesesMaximo,
                idade_dias_maximo: this.model.idadeDiasMaximo,
            }
        },
        fields() {
            const agrupadosFields = [
                {key: 'unidadeNomeFantasia', label: 'Unidade', sortable: true},
                {key: 'equipeDescricao', label: 'Equipe', sortable: true},
                {key: 'denominador', label: 'Denominador', sortable: true},
                {key: 'numerador', label: 'Numerador', sortable: true},
                {formatter: (value) => `${value}%`, key: 'resultado', label: 'Resultado', sortable: true},
                {key: 'classificacao', label: 'Classificação', sortable: true},
            ]

            const desagrupadosFields = [
                {key: 'unidadeNomeFantasia', label: 'Unidade', sortable: true},
                {key: 'equipeDescricao', label: 'Equipe', sortable: true},
                {key: 'pacienteNome', label: 'Paciente', sortable: true},
                {key: 'pacienteSexoDescricao', label: 'Sexo', sortable: true},
                {key: 'pacienteDataNascimento', label: 'Data de Nascimento', sortable: true},
                {key: 'pacienteIdade', label: 'Idade', sortable: true},
            ]

            if (this.model && this.model.boasPraticas.filter(boaPratica => boaPratica === 'A').length > 0) {
                agrupadosFields.push({formatter: (value) => `${value}%`, key: 'percentualBoasPraticasA', label: '% Boa prática A'})
                desagrupadosFields.push({key: 'boaPraticaA', label: 'Boa prática A'})
            }

            if (this.model && this.model.boasPraticas.filter(boaPratica => boaPratica === 'B').length > 0) {
                agrupadosFields.push({formatter: (value) => `${value}%`, key: 'percentualBoasPraticasB', label: '% Boa prática B'})
                desagrupadosFields.push({key: 'boaPraticaB', label: 'Boa prática B'})
            }

            if (this.model && this.model.boasPraticas.filter(boaPratica => boaPratica === 'C').length > 0) {
                agrupadosFields.push({formatter: (value) => `${value}%`, key: 'percentualBoasPraticasC', label: '% Boa prática C'})
                desagrupadosFields.push({key: 'boaPraticaC', label: 'Boa prática C'})
            }

            if (this.model && this.model.boasPraticas.filter(boaPratica => boaPratica === 'D').length > 0) {
                agrupadosFields.push({formatter: (value) => `${value}%`, key: 'percentualBoasPraticasD', label: '% Boa prática D'})
                desagrupadosFields.push({key: 'boaPraticaD', label: 'Boa prática D'})
            }

            if (this.model && this.model.boasPraticas.filter(boaPratica => boaPratica === 'E').length > 0) {
                agrupadosFields.push({formatter: (value) => `${value}%`, key: 'percentualBoasPraticasE', label: '% Boa prática E'})
                desagrupadosFields.push({key: 'boaPraticaE', label: 'Boa prática E'})
            }

            if (this.model && this.model.boasPraticas.filter(boaPratica => boaPratica === 'F').length > 0) {
                agrupadosFields.push({formatter: (value) => `${value}%`, key: 'percentualBoasPraticasF', label: '% Boa prática F'})
                desagrupadosFields.push({key: 'boaPraticaF', label: 'Boa prática F'})
            }

            desagrupadosFields.push({key: 'pontuacaoTotal', label: 'Pontuação total'})

            return {
                autocomplete: [
                    {key: 'cadastroCidadao.nome', searchable: true},
                    {key: 'cadastroCidadao.nomeSocial', searchable: true},
                    {key: 'cadastroCidadao.data_nascimento', searchable: true},
                    {key: 'cadastroPaciente.prontuario', searchable: true},
                ],
                table: {
                    agrupados: agrupadosFields,
                    desagrupados: desagrupadosFields,
                },
            }
        },
    },
    created() {
        this.repositories = {
            exportacao: this.getConectaSusRepository('exportacao.atencaoBasica'),
            impressao: this.getConectaSusRepository('impressao.atencaoBasica'),
            relatorioCuidadoPessoaComDiabete: this.getConectaSusRepository('atencaoBasica.relatorioCuidadoPessoaComDiabete'),
        }

        this.load()
    },
    data: () => ({
        form: null,
        itensAgrupados: [],
        itensDesagrupados: [],
        model: null,
        others: {moment},
        sortByAgrupados: 'unidadeNomeFantasia',
        sortDescAgrupados: false,
        sortByDesagrupados: 'unidadeNomeFantasia',
        sortDescDesagrupados: false,
        totalizadores: null,
        unwatchers: {
            periodo: null,
        },
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {
            this.setLoading()

            this.repositories.relatorioCuidadoPessoaComDiabete.create()
                .then((response) => {
                    this.form = response.data.form
                    this.model = response.data.model

                    this.addWatchers()
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleAnoChange() {
            this.removeWatchers()

            this.form.unidades = []
            this.form.equipes = []
            this.form.sexos = []
            this.model.periodo = {start: null, end: null}
            this.model.quadrimestre = null
            this.model.unidadeId = null
            this.model.equipeId = null
            this.model.boasPraticas = ['A', 'B', 'C', 'D', 'E', 'F']
            this.model.sexoId = null
            this.model.idadeAnosMinimo = null
            this.model.idadeMesesMinimo = null
            this.model.idadeDiasMinimo = null
            this.model.idadeAnosMaximo = null
            this.model.idadeMesesMaximo = null
            this.model.idadeDiasMaximo = null
            this.model.paciente = null
            this.model.buscaAtiva = false

            this.totalizadores = null
            this.itensAgrupados = []
            this.itensDesagrupados = []

            this.addWatchers()
        },
        handleQuadrimestreChange(value) {
            this.removeWatchers()

            this.form.unidades = []
            this.form.equipes = []
            this.form.sexos = []
            this.model.periodo = {start: null, end: null}
            this.model.unidadeId = null
            this.model.equipeId = null
            this.model.boasPraticas = ['A', 'B', 'C', 'D', 'E', 'F']
            this.model.sexoId = null
            this.model.idadeAnosMinimo = null
            this.model.idadeMesesMinimo = null
            this.model.idadeDiasMinimo = null
            this.model.idadeAnosMaximo = null
            this.model.idadeMesesMaximo = null
            this.model.idadeDiasMaximo = null
            this.model.paciente = null
            this.model.buscaAtiva = false

            this.totalizadores = null
            this.itensAgrupados = []
            this.itensDesagrupados = []

            this.addWatchers()

            const request = {
                listar: 'unidades',
                periodo: {
                    start: this.model.periodo.start ? this.others.moment(this.model.periodo.start).format('DD/MM/YYYY') : null,
                    end: this.model.periodo.end ? this.others.moment(this.model.periodo.end).format('DD/MM/YYYY') : null,
                },
                ano: this.model.ano,
                quadrimestre: value,
            }

            this.setLoading()

            this.repositories.relatorioCuidadoPessoaComDiabete.list(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    this.form.unidades = Object.assign(response.data.unidades)
                    this.form.equipes = Object.assign(response.data.equipes)
                    this.form.sexos = Object.assign(response.data.sexos)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleUnidadeChange(value) {
            this.form.equipes = []
            this.form.sexos = []
            this.model.equipeId = null
            this.model.boasPraticas = ['A', 'B', 'C', 'D', 'E', 'F']
            this.model.sexoId = null
            this.model.idadeAnosMinimo = null
            this.model.idadeMesesMinimo = null
            this.model.idadeDiasMinimo = null
            this.model.idadeAnosMaximo = null
            this.model.idadeMesesMaximo = null
            this.model.idadeDiasMaximo = null
            this.model.paciente = null
            this.model.buscaAtiva = false

            this.totalizadores = null
            this.itensAgrupados = []
            this.itensDesagrupados = []

            const request = {
                listar: 'equipes',
                periodo: {
                    start: this.model.periodo.start ? this.others.moment(this.model.periodo.start).format('DD/MM/YYYY') : null,
                    end: this.model.periodo.end ? this.others.moment(this.model.periodo.end).format('DD/MM/YYYY') : null,
                },
                ano: this.model.ano,
                quadrimestre: this.model.quadrimestre,
                unidadeId: value,
            }

            this.setLoading()

            this.repositories.relatorioCuidadoPessoaComDiabete.list(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    this.form.equipes = Object.assign(response.data.equipes)
                    this.form.sexos = Object.assign(response.data.sexos)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleEquipeChange(value) {
            this.form.sexos = []
            this.model.boasPraticas = ['A', 'B', 'C', 'D', 'E', 'F']
            this.model.sexoId = null
            this.model.idadeAnosMinimo = null
            this.model.idadeMesesMinimo = null
            this.model.idadeDiasMinimo = null
            this.model.idadeAnosMaximo = null
            this.model.idadeMesesMaximo = null
            this.model.idadeDiasMaximo = null
            this.model.paciente = null
            this.model.buscaAtiva = false

            this.totalizadores = null
            this.itensAgrupados = []
            this.itensDesagrupados = []

            const request = {
                listar: 'equipes',
                periodo: {
                    start: this.model.periodo.start ? this.others.moment(this.model.periodo.start).format('DD/MM/YYYY') : null,
                    end: this.model.periodo.end ? this.others.moment(this.model.periodo.end).format('DD/MM/YYYY') : null,
                },
                ano: this.model.ano,
                quadrimestre: this.model.quadrimestre,
                unidadeId: this.model.unidadeId,
                equipeId: value,
            }

            this.setLoading()

            this.repositories.relatorioCuidadoPessoaComDiabete.list(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => this.form.sexos = Object.assign(response.data.sexos))
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleSexoChange() {
            this.model.idadeAnosMinimo = null
            this.model.idadeMesesMinimo = null
            this.model.idadeDiasMinimo = null
            this.model.idadeAnosMaximo = null
            this.model.idadeMesesMaximo = null
            this.model.idadeDiasMaximo = null
            this.model.paciente = null
            this.model.buscaAtiva = false

            this.totalizadores = null
            this.itensAgrupados = []
            this.itensDesagrupados = []
        },
        handleIdadeAnosMinimoChange() {
            this.model.paciente = null
            this.model.buscaAtiva = false

            this.totalizadores = null
            this.itensAgrupados = []
            this.itensDesagrupados = []
        },
        handleIdadeMesesMinimoChange() {
            this.model.paciente = null
            this.model.buscaAtiva = false

            this.totalizadores = null
            this.itensAgrupados = []
            this.itensDesagrupados = []
        },
        handleIdadeDiasMinimoChange() {
            this.model.paciente = null
            this.model.buscaAtiva = false

            this.totalizadores = null
            this.itensAgrupados = []
            this.itensDesagrupados = []
        },
        handleIdadeAnosMaximoChange() {
            this.model.paciente = null
            this.model.buscaAtiva = false

            this.totalizadores = null
            this.itensAgrupados = []
            this.itensDesagrupados = []
        },
        handleIdadeMesesMaximoChange() {
            this.model.paciente = null
            this.model.buscaAtiva = false

            this.totalizadores = null
            this.itensAgrupados = []
            this.itensDesagrupados = []
        },
        handleIdadeDiasMaximoChange() {
            this.model.paciente = null
            this.model.buscaAtiva = false

            this.totalizadores = null
            this.itensAgrupados = []
            this.itensDesagrupados = []
        },
        addWatchers() {
            this.unwatchers.periodo = this.$watch('model.periodo', {
                deep: true,
                handler() {
                    this.form.unidades = []
                    this.form.equipes = []
                    this.form.sexos = []
                    this.model.ano = null
                    this.model.quadrimestre = null
                    this.model.unidadeId = null
                    this.model.equipeId = null
                    this.model.boasPraticas = ['A', 'B', 'C', 'D', 'E', 'F']
                    this.model.sexoId = null
                    this.model.idadeAnosMinimo = null
                    this.model.idadeMesesMinimo = null
                    this.model.idadeDiasMinimo = null
                    this.model.idadeAnosMaximo = null
                    this.model.idadeMesesMaximo = null
                    this.model.idadeDiasMaximo = null
                    this.model.paciente = null
                    this.model.buscaAtiva = false

                    this.totalizadores = null
                    this.itensAgrupados = []
                    this.itensDesagrupados = []

                    if (this.model.periodo.start === null || this.model.periodo.end === null)  {
                        return
                    }

                    const request = {
                        listar: 'unidades',
                        periodo: {
                            start: this.others.moment(this.model.periodo.start).format('DD/MM/YYYY'),
                            end: this.others.moment(this.model.periodo.end).format('DD/MM/YYYY'),
                        },
                        ano: this.model.ano,
                        quadrimestre: this.model.quadrimestre,
                    }

                    this.setLoading()

                    this.repositories.relatorioCuidadoPessoaComDiabete.list(this.camelObjectKeysToSnakeRecursive(request))
                        .then(response => {
                            this.form.unidades = Object.assign(response.data.unidades)
                            this.form.equipes = Object.assign(response.data.equipes)
                            this.form.sexos = Object.assign(response.data.sexos)
                        })
                        .catch(this.handleError)
                        .finally(() => this.unsetLoading())
                }
            })
        },
        removeWatchers() {
            this.unwatchers.periodo()
        },
        search() {
            const request = {
                periodo: {
                    start: this.model.periodo.start ? this.others.moment(this.model.periodo.start).format('DD/MM/YYYY') : null,
                    end: this.model.periodo.end ? this.others.moment(this.model.periodo.end).format('DD/MM/YYYY') : null,
                },
                ano: this.model.ano,
                quadrimestre: this.model.quadrimestre,
                unidadeId: this.model.unidadeId,
                equipeId: this.model.equipeId,
                boasPraticas: this.model.boasPraticas,
                sexoId: this.model.sexoId,
                idadeAnosMinimo: this.model.idadeAnosMinimo,
                idadeMesesMinimo: this.model.idadeMesesMinimo,
                idadeDiasMinimo: this.model.idadeDiasMinimo,
                idadeAnosMaximo: this.model.idadeAnosMaximo,
                idadeMesesMaximo: this.model.idadeMesesMaximo,
                idadeDiasMaximo: this.model.idadeDiasMaximo,
                pacienteId: this.model.paciente ? this.model.paciente.id : null,
                buscaAtiva: this.model.buscaAtiva,
            }

            this.setLoading()

            this.repositories.relatorioCuidadoPessoaComDiabete.index(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    this.totalizadores = response.data.totalizadores
                    this.itensAgrupados = response.data.itensAgrupados
                    this.itensDesagrupados = response.data.itensDesagrupados
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        reset() {
            this.form.unidades = []
            this.form.equipes = []
            this.form.sexos = []
            this.model.periodo = {start: null, end: null}
            this.model.ano = null
            this.model.quadrimestre = null
            this.model.unidadeId = null
            this.model.equipeId = null
            this.model.boasPraticas = ['A', 'B', 'C', 'D', 'E', 'F']
            this.model.sexoId = null
            this.model.idadeAnosMinimo = null
            this.model.idadeMesesMinimo = null
            this.model.idadeDiasMinimo = null
            this.model.idadeAnosMaximo = null
            this.model.idadeMesesMaximo = null
            this.model.idadeDiasMaximo = null
            this.model.paciente = null
            this.model.buscaAtiva = false

            this.itensAgrupados = []
            this.itensDesagrupados = []
            this.totalizadores = null

            this.$refs.Form.resetValidator()
        },
        print() {
            this.setLoading()

            const request = {
                periodo: {
                    start: this.model.periodo.start ? this.others.moment(this.model.periodo.start).format('DD/MM/YYYY') : null,
                    end: this.model.periodo.end ? this.others.moment(this.model.periodo.end).format('DD/MM/YYYY') : null,
                },
                ano: this.model.ano,
                quadrimestre: this.model.quadrimestre,
                unidadeId: this.model.unidadeId,
                equipeId: this.model.equipeId,
                boasPraticas: this.model.boasPraticas,
                sexoId: this.model.sexoId,
                idadeAnosMinimo: this.model.idadeAnosMinimo,
                idadeMesesMinimo: this.model.idadeMesesMinimo,
                idadeDiasMinimo: this.model.idadeDiasMinimo,
                idadeAnosMaximo: this.model.idadeAnosMaximo,
                idadeMesesMaximo: this.model.idadeMesesMaximo,
                idadeDiasMaximo: this.model.idadeDiasMaximo,
                pacienteId: this.model.paciente ? this.model.paciente.id : null,
                buscaAtiva: this.model.buscaAtiva,
                sortByAgrupados: this.sortByAgrupados ? this.camelToSnake(this.sortByAgrupados) : null,
                sortDescAgrupados: this.sortDescAgrupados,
                sortByDesagrupados: this.sortByDesagrupados ? this.camelToSnake(this.sortByDesagrupados) : null,
                sortDescDesagrupados: this.sortDescDesagrupados,
            }

            this.repositories.impressao.relatorioCuidadoPessoaComDiabete(this.camelObjectKeysToSnakeRecursive(request))
                .then(({ data, headers }) => this.openFile(data, headers['content-type']))
                .finally(() => this.unsetLoading())
        },
        exportTo() {
            this.setLoading()

            const request = {
                periodo: {
                    start: this.model.periodo.start ? this.others.moment(this.model.periodo.start).format('DD/MM/YYYY') : null,
                    end: this.model.periodo.end ? this.others.moment(this.model.periodo.end).format('DD/MM/YYYY') : null,
                },
                ano: this.model.ano,
                quadrimestre: this.model.quadrimestre,
                unidadeId: this.model.unidadeId,
                equipeId: this.model.equipeId,
                boasPraticas: this.model.boasPraticas,
                sexoId: this.model.sexoId,
                idadeAnosMinimo: this.model.idadeAnosMinimo,
                idadeMesesMinimo: this.model.idadeMesesMinimo,
                idadeDiasMinimo: this.model.idadeDiasMinimo,
                idadeAnosMaximo: this.model.idadeAnosMaximo,
                idadeMesesMaximo: this.model.idadeMesesMaximo,
                idadeDiasMaximo: this.model.idadeDiasMaximo,
                pacienteId: this.model.paciente ? this.model.paciente.id : null,
                buscaAtiva: this.model.buscaAtiva,
                sortByAgrupados: this.sortByAgrupados ? this.camelToSnake(this.sortByAgrupados) : null,
                sortDescAgrupados: this.sortDescAgrupados,
                sortByDesagrupados: this.sortByDesagrupados ? this.camelToSnake(this.sortByDesagrupados) : null,
                sortDescDesagrupados: this.sortDescDesagrupados,
            }

            this.repositories.exportacao.relatorioCuidadoPessoaComDiabete(this.camelObjectKeysToSnakeRecursive(request))
                .then(({ data, headers }) => this.openFile(data, headers['content-type']))
                .finally(() => this.unsetLoading())
        },
        onSortChangedAgrupados(context) {
            this.sortByAgrupados = context.sortBy
            this.sortDescAgrupados = context.sortDesc
        },
        onSortChangedDesagrupados(context) {
            this.sortByDesagrupados = context.sortBy
            this.sortDescDesagrupados = context.sortDesc
        },
    },
    mixins: [error, file, repository, stringCase],
}
</script>